const PlusIcon = () => {
    return (
        <svg className={"svg-icon"} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 12H20.25" stroke="#007626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 3.75V20.25" stroke="#007626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default PlusIcon